var _style, _circle, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoTextLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3000 3000",
    style: {
      enableBackground: "new 0 0 3000 3000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);stroke:#000000;stroke-miterlimit:10;}\n\t.st1{fill:url(#SVGID_00000154411576307099646610000005279104768377694880_);stroke:#000000;stroke-miterlimit:10;}\n\t.st2{fill:url(#SVGID_00000044138625741675307660000010433015430962417822_);stroke:#000000;stroke-miterlimit:10;}\n\t.st3{fill:url(#SVGID_00000175295556194482098880000004660904592952549033_);stroke:#000000;stroke-miterlimit:10;}\n\t.st4{fill:url(#SVGID_00000105427522885573351590000004882800821581428385_);stroke:#000000;stroke-miterlimit:10;}\n\t.st5{fill:url(#SVGID_00000115505802244664285730000011014074485904361604_);stroke:#000000;stroke-miterlimit:10;}\n\t.st6{fill:url(#SVGID_00000013160171128793768660000002461421913670087345_);}\n\t.st7{fill:#82368C;}\n\t.st8{fill:url(#SVGID_00000104699366553486903160000014087111422992742302_);}\n\t.st9{fill:url(#SVGID_00000179640146685288945960000004958981820649346964_);}\n\t.st10{fill:#2D2E83;}\n\t.st11{fill:url(#SVGID_00000102525916644415811230000009972595227383502489_);}\n\t.st12{fill:url(#SVGID_00000125602293912232534780000004627258248146345372_);}\n\t.st13{fill:url(#SVGID_00000168083005023989773130000017066108045246312324_);}\n\t.st14{fill:url(#SVGID_00000181058219321782741490000008244300694375514535_);stroke:#000000;stroke-miterlimit:10;}\n\t.st15{fill:url(#SVGID_00000042722817062137995130000004753004328407143337_);stroke:#000000;stroke-miterlimit:10;}\n\t.st16{fill:url(#SVGID_00000106863382306847891890000005628887758653508230_);stroke:#000000;stroke-miterlimit:10;}\n\t.st17{fill:url(#SVGID_00000139270895233708090320000006334324111455535030_);stroke:#000000;stroke-miterlimit:10;}\n\t.st18{fill:url(#SVGID_00000036251871604009536930000002478525732361542041_);stroke:#000000;stroke-miterlimit:10;}\n\t.st19{fill:url(#SVGID_00000113334883671674602940000016584316353467176096_);stroke:#000000;stroke-miterlimit:10;}\n\t.st20{fill:url(#SVGID_00000157275799922163256530000017949781544040164799_);stroke:#000000;stroke-miterlimit:10;}\n\t.st21{fill:url(#SVGID_00000047045963347655947840000003016936803294135680_);stroke:#000000;stroke-miterlimit:10;}\n\t.st22{fill:url(#SVGID_00000011016022629303748100000007184869850209280150_);stroke:#000000;stroke-miterlimit:10;}\n\t.st23{fill:url(#SVGID_00000158749649559708110820000012039698855970048956_);stroke:#000000;stroke-miterlimit:10;}\n\t.st24{fill:url(#SVGID_00000042009479140834220200000002927535911589878695_);stroke:#000000;stroke-miterlimit:10;}\n\t.st25{fill:url(#SVGID_00000160177480858857455330000018334104070187166604_);stroke:#000000;stroke-miterlimit:10;}\n\t.st26{display:none;}\n\t.st27{display:inline;fill:#252957;stroke:#000000;stroke-miterlimit:10;}\n\t.st28{display:inline;fill:#902D88;stroke:#000000;stroke-miterlimit:10;}\n\t.st29{display:inline;fill:#433186;stroke:#000000;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1025.5416,
    y1: 863.3661,
    x2: 1110.6653,
    y2: 814.22
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C2D88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    style: {
      stopColor: "#972E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1064,
    style: {
      stopColor: "#882F88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2071,
    style: {
      stopColor: "#7B3088"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    style: {
      stopColor: "#723088"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5067,
    style: {
      stopColor: "#6C3088"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9925,
    style: {
      stopColor: "#6B3088"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1068.1,
    cy: 838.79,
    r: 49.14
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026148264694589976380000008194803790221438108_",
    gradientUnits: "userSpaceOnUse",
    x1: 1889.3347,
    y1: 863.3661,
    x2: 1974.4584,
    y2: 814.22
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.9975,
    style: {
      stopColor: "#2E3985"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#283985"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000026148264694589976380000008194803790221438108_)",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    cx: 1931.9,
    cy: 838.79,
    r: 49.14
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137121514518575001850000006101033649745774221_",
    gradientUnits: "userSpaceOnUse",
    x1: 662.6106,
    y1: 1515.9868,
    x2: 747.7342,
    y2: 1466.8407
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C2D88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9159,
    style: {
      stopColor: "#9B2E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9899,
    style: {
      stopColor: "#9A2E88"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000137121514518575001850000006101033649745774221_)",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    cx: 705.17,
    cy: 1491.41,
    r: 49.14
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043432146962734539490000017449821931152363650_",
    gradientUnits: "userSpaceOnUse",
    x1: 2276.7141,
    y1: 1515.9868,
    x2: 2361.8376,
    y2: 1466.8407
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.9975,
    style: {
      stopColor: "#2E3985"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#283985"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000043432146962734539490000017449821931152363650_)",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    cx: 2319.28,
    cy: 1491.41,
    r: 49.14
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062898278640691142070000007974501955688123038_",
    gradientUnits: "userSpaceOnUse",
    x1: 1092.6765,
    y1: 2249.4583,
    x2: 1043.5304,
    y2: 2164.3347
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C2D88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0608,
    style: {
      stopColor: "#922E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1661,
    style: {
      stopColor: "#862F88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2973,
    style: {
      stopColor: "#7D2F88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4814,
    style: {
      stopColor: "#783088"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9925,
    style: {
      stopColor: "#763088"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000062898278640691142070000007974501955688123038_)",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    cx: 1068.1,
    cy: 2206.9,
    r: 49.14
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160872209790616778530000015714884674580720048_",
    gradientUnits: "userSpaceOnUse",
    x1: 1875.5416,
    y1: 2231.4697,
    x2: 1960.6653,
    y2: 2182.3235
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.9975,
    style: {
      stopColor: "#2E3985"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#283985"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000160872209790616778530000015714884674580720048_)",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    cx: 1918.1,
    cy: 2206.9,
    r: 49.14
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126322197584723640360000015552811390020808871_",
    gradientUnits: "userSpaceOnUse",
    x1: 1212.9192,
    y1: 1161.444,
    x2: 1470.1327,
    y2: 1012.9417
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C2D88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0633,
    style: {
      stopColor: "#8C3188"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1724,
    style: {
      stopColor: "#723588"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2904,
    style: {
      stopColor: "#5C3787"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4184,
    style: {
      stopColor: "#493886"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5613,
    style: {
      stopColor: "#3B3986"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7312,
    style: {
      stopColor: "#323985"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9975,
    style: {
      stopColor: "#2E3985"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#283985"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126322197584723640360000015552811390020808871_)"
    },
    d: "M1293.97,1301.82 c38.76-270.7,15.89-167.52,95.12-429.26"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1303.61,1304.48c5.8-40.49,11.35-81.01,16.9-121.53c3.13-22.87,6.17-45.78,10.06-68.54 c2.84-16.61,6.35-33.08,10.65-49.37c5.55-21.02,12.01-41.8,18.42-62.57c11.18-36.25,22.44-72.47,33.49-108.77 c1.87-6.16,3.74-12.32,5.61-18.47c1.52-5.01-1.81-11.12-6.98-12.3c-5.4-1.23-10.68,1.62-12.3,6.98 c-11.85,39.15-23.93,78.22-36.02,117.29c-6.82,22.06-13.75,44.1-19.84,66.38c-4.45,16.26-8.22,32.66-11.2,49.25 c-3.85,21.4-6.77,42.96-9.74,64.49c-5.18,37.58-10.27,75.17-15.6,112.73c-0.9,6.37-1.81,12.74-2.72,19.11 c-0.4,2.78-0.47,5.18,1.01,7.71c1.21,2.07,3.59,4.05,5.98,4.6C1296.03,1312.54,1302.82,1310.02,1303.61,1304.48L1303.61,1304.48z "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183213258837164821430000015278761872994063757_",
    gradientUnits: "userSpaceOnUse",
    x1: 930.1987,
    y1: 1304.4513,
    x2: 1240.9038,
    y2: 1615.1564
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1608,
    style: {
      stopColor: "#9C2D88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2968,
    style: {
      stopColor: "#992E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4466,
    style: {
      stopColor: "#8F3088"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603,
    style: {
      stopColor: "#7E3388"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    style: {
      stopColor: "#663687"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    style: {
      stopColor: "#433886"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9975,
    style: {
      stopColor: "#2E3985"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183213258837164821430000015278761872994063757_)"
    },
    d: "M1238.42,1617.64 c-201.16-185.25-129.07-107.97-299.92-321.49"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1245.49,1610.57c-17.19-15.83-34.43-31.62-51.7-47.37c-12.91-11.77-25.85-23.52-38.77-35.28 c-9.67-8.8-19.34-17.59-28.94-26.47c-7.42-6.86-14.8-13.76-22.04-20.81c-6.05-5.89-12.01-11.87-17.81-18.01 c-5.72-6.06-11.29-12.27-16.72-18.58c-6.23-7.24-12.31-14.61-18.32-22.03c-7.69-9.49-15.28-19.05-22.86-28.63 c-10.14-12.81-20.26-25.65-30.4-38.47c-13.5-17.06-27.02-34.1-40.59-51.11c-3.92-4.91-7.84-9.82-11.76-14.72 c-1.5-1.87-4.79-2.93-7.07-2.93c-2.45,0-5.38,1.09-7.07,2.93c-1.75,1.91-3.05,4.41-2.93,7.07c0.13,2.81,1.18,4.89,2.93,7.07 c14.6,18.25,29.16,36.54,43.67,54.86c10.85,13.7,21.67,27.42,32.5,41.12c8.1,10.26,16.21,20.51,24.4,30.7 c6.33,7.88,12.71,15.72,19.23,23.43c5.45,6.45,11.01,12.8,16.74,19.01c5.65,6.13,11.46,12.11,17.38,17.97 c6.79,6.72,13.72,13.29,20.71,19.81c8.93,8.33,17.95,16.56,26.98,24.79c12.08,11.01,24.18,21.99,36.27,32.99 c16.09,14.65,32.15,29.32,48.17,44.04c4.63,4.25,9.25,8.5,13.87,12.76c3.85,3.54,10.39,4.09,14.14,0 C1249.03,1620.86,1249.6,1614.36,1245.49,1610.57L1245.49,1610.57z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049922096767091657470000013976078686658841523_",
    gradientUnits: "userSpaceOnUse",
    x1: 1935.3691,
    y1: 1635.9027,
    x2: 2023.6652,
    y2: 1584.9249
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C2D88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0305,
    style: {
      stopColor: "#982E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3542,
    style: {
      stopColor: "#703587"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#4F3886"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    style: {
      stopColor: "#383985"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9975,
    style: {
      stopColor: "#2E3985"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#283985"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049922096767091657470000013976078686658841523_)"
    },
    d: "M1828.45,1450.71 c202.44,183.85,129.81,107.07,302.14,319.41"
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1821.38,1457.78c17.32,15.73,34.67,31.41,52.07,47.05c12.96,11.65,25.94,23.28,38.91,34.92 c9.77,8.77,19.55,17.54,29.25,26.39c7.42,6.76,14.8,13.57,22.04,20.52c6.15,5.89,12.2,11.89,18.08,18.04 c5.72,5.98,11.29,12.11,16.74,18.35c6.31,7.23,12.47,14.6,18.56,22.01c7.73,9.41,15.37,18.9,23,28.4 c10.24,12.76,20.46,25.53,30.69,38.29c13.57,16.92,27.17,33.81,40.82,50.67c3.99,4.92,7.97,9.85,11.97,14.77 c1.52,1.87,4.77,2.93,7.07,2.93c2.45,0,5.38-1.09,7.07-2.93c1.75-1.91,3.05-4.41,2.93-7.07c-0.13-2.8-1.17-4.9-2.93-7.07 c-14.74-18.16-29.43-36.36-44.08-54.6c-10.91-13.59-21.8-27.19-32.7-40.79c-8.21-10.25-16.43-20.49-24.72-30.67 c-6.34-7.78-12.73-15.53-19.26-23.15c-5.54-6.47-11.19-12.84-17.01-19.06c-5.66-6.05-11.47-11.95-17.39-17.73 c-6.87-6.7-13.88-13.26-20.95-19.76c-8.97-8.24-18.02-16.4-27.08-24.54c-12.17-10.93-24.36-21.84-36.53-32.77 c-16.14-14.49-32.25-29.01-48.33-43.57c-4.7-4.25-9.39-8.51-14.08-12.77c-3.87-3.52-10.37-4.11-14.14,0 C1817.86,1447.47,1817.24,1454.03,1821.38,1457.78L1821.38,1457.78z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021836283278357208610000007002559835033547914_",
    gradientUnits: "userSpaceOnUse",
    x1: 1506.7764,
    y1: 2077.9478,
    x2: 1794.4302,
    y2: 1911.8707
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C2D88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0305,
    style: {
      stopColor: "#982E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3542,
    style: {
      stopColor: "#703587"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#4F3886"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    style: {
      stopColor: "#383985"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9975,
    style: {
      stopColor: "#2E3985"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#283985"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021836283278357208610000007002559835033547914_)"
    },
    d: "M1722.41,1787.13 c-69.48,264.49-34.96,164.6-143.62,415.55"
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1712.77,1784.48c-5.91,22.49-11.76,44.99-17.55,67.51c-4.37,16.99-8.71,33.99-13.07,50.98 c-3.24,12.65-6.48,25.3-9.83,37.92c-2.59,9.77-5.23,19.53-8.06,29.23c-2.37,8.12-4.87,16.21-7.59,24.22 c-2.67,7.88-5.54,15.69-8.57,23.45c-1.65,4.23-3.35,8.44-5.07,12.64c-0.92,2.24-1.85,4.47-2.78,6.7 c-0.23,0.55-0.46,1.11-0.7,1.66c-0.12,0.28-0.24,0.56-0.35,0.84c-0.5,1.18,1.14-2.69,0.47-1.12c-0.51,1.2-1.02,2.4-1.52,3.59 c-4.8,11.27-9.71,22.5-14.64,33.72c-6.53,14.87-13.1,29.74-19.64,44.61c-8.78,19.96-17.52,39.94-26.21,59.94 c-2.5,5.76-5,11.51-7.49,17.27c-1.11,2.56-1.78,4.89-1.01,7.71c0.64,2.32,2.43,4.83,4.6,5.98c4.31,2.28,11.46,1.54,13.68-3.59 c9.28-21.43,18.61-42.83,28-64.22c7.04-16.04,14.11-32.07,21.17-48.1c5.28-11.99,10.55-23.97,15.73-36 c4.28-9.93,8.5-19.89,12.53-29.93c3.17-7.89,6.21-15.84,9.04-23.86c2.77-7.85,5.33-15.77,7.74-23.74 c2.76-9.16,5.33-18.38,7.82-27.62c3.18-11.81,6.24-23.66,9.29-35.51c4.06-15.8,8.09-31.61,12.15-47.42 c5.42-21.12,10.88-42.23,16.39-63.33c1.59-6.07,3.18-12.14,4.77-18.21c1.33-5.05-1.68-11.09-6.98-12.3 C1719.84,1776.3,1714.19,1779.06,1712.77,1784.48L1712.77,1784.48z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083788104464186738050000009064682822635906491_",
    gradientUnits: "userSpaceOnUse",
    x1: 1079.4983,
    y1: 1767.246,
    x2: 1284.2948,
    y2: 1972.0425
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    style: {
      stopColor: "#9C2D88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0888,
    style: {
      stopColor: "#8F3088"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2834,
    style: {
      stopColor: "#703588"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4752,
    style: {
      stopColor: "#563787"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6611,
    style: {
      stopColor: "#423886"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8382,
    style: {
      stopColor: "#343985"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9975,
    style: {
      stopColor: "#2E3985"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083788104464186738050000009064682822635906491_)"
    },
    d: "M1401.25,1855.09 c-270.71,38.74-165.25,31.74-438.7,29.11"
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1398.59,1845.45c-40.49,5.8-80.95,11.83-121.4,17.87c-12.9,1.93-25.79,3.85-38.7,5.67 c-2.71,0.38-5.42,0.76-8.14,1.13c-0.57,0.08-1.13,0.15-1.7,0.23c-0.34,0.05-0.67,0.09-1.01,0.14c-1.59,0.22,2.91-0.39,1.32-0.18 c-1.31,0.17-2.62,0.35-3.93,0.52c-4.69,0.61-9.38,1.2-14.08,1.74c-16.65,1.92-33.34,3.16-50.09,3.59 c-21.73,0.57-43.49,0.2-65.22-0.13c-37.93-0.56-75.86-1.21-113.79-1.63c-6.43-0.07-12.87-0.14-19.3-0.2 c-5.23-0.05-10.24,4.64-10,10c0.24,5.46,4.39,9.95,10,10c40.9,0.39,81.8,1.03,122.7,1.67c23.18,0.36,46.38,0.83,69.56,0.42 c16.75-0.3,33.47-1.28,50.13-3.06c22.51-2.4,44.91-5.78,67.29-9.1c37.52-5.57,75.03-11.22,112.57-16.65 c6.37-0.92,12.74-1.84,19.11-2.75c2.3-0.33,4.86-2.69,5.98-4.6c1.25-2.14,1.79-5.3,1.01-7.71c-0.78-2.42-2.28-4.75-4.6-5.98 C1403.75,1845.11,1401.41,1845.04,1398.59,1845.45L1398.59,1845.45z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101061804966782389710000008659826168903306934_",
    gradientUnits: "userSpaceOnUse",
    x1: 1616.3793,
    y1: 1189.442,
    x2: 2053.6211,
    y2: 1189.442
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.9975,
    style: {
      stopColor: "#2E3985"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#2B3985"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#283985"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101061804966782389710000008659826168903306934_)"
    },
    d: "M1616.38,1212.5 c269-49.22,163.89-38.13,437.24-46.13"
  }), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1619.04,1222.15c40.15-7.35,80.25-14.93,120.35-22.52c22.76-4.31,45.52-8.72,68.41-12.28 c4.26-0.66,8.52-1.28,12.79-1.87c1.44-0.2-3.03,0.4-1.58,0.21c0.27-0.04,0.54-0.07,0.8-0.11c0.49-0.06,0.98-0.13,1.47-0.19 c1.1-0.14,2.21-0.28,3.31-0.42c2.01-0.25,4.02-0.48,6.04-0.71c8.26-0.92,16.55-1.62,24.85-2.16c21.63-1.41,43.31-1.88,64.98-2.4 c38.01-0.91,76.02-1.74,114.03-2.8c6.38-0.18,12.76-0.36,19.14-0.55c5.22-0.15,10.25-4.49,10-10c-0.24-5.29-4.4-10.16-10-10 c-40.96,1.2-81.92,2.15-122.88,3.1c-23.09,0.53-46.21,0.97-69.28,2.28c-17.58,0.99-35.06,2.79-52.48,5.33 c-21.54,3.14-42.94,7.23-64.32,11.25c-37.37,7.04-74.71,14.16-112.11,21.06c-6.28,1.16-12.55,2.31-18.83,3.46 c-5.16,0.94-8.55,7.48-6.98,12.3C1608.53,1220.69,1613.51,1223.16,1619.04,1222.15L1619.04,1222.15z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095333897855062184200000001399818353364455848_",
    gradientUnits: "userSpaceOnUse",
    x1: 1678.4609,
    y1: 735.7587,
    x2: 1321.5391,
    y2: 941.8276
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#283985"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.002512563,
    style: {
      stopColor: "#463187"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5238,
    style: {
      stopColor: "#483187"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7115,
    style: {
      stopColor: "#4E3188"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8453,
    style: {
      stopColor: "#583188"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9528,
    style: {
      stopColor: "#663088"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6E3088"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000095333897855062184200000001399818353364455848_)",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    cx: 1500,
    cy: 838.79,
    r: 206.03
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171000600046952998770000017795858340449220016_",
    gradientUnits: "userSpaceOnUse",
    x1: 2343.9656,
    y1: 1166.3793,
    x2: 1931.8966,
    y2: 1166.3793
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002512563,
    style: {
      stopColor: "#2E3985"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F3985"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000171000600046952998770000017795858340449220016_)",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    cx: 2137.93,
    cy: 1166.38,
    r: 206.03
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067951552607195656910000006693194055658498237_",
    gradientUnits: "userSpaceOnUse",
    x1: 1945.677,
    y1: 1919.4827,
    x2: 2302.5989,
    y2: 1713.4138
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.9975,
    style: {
      stopColor: "#2E3985"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#283985"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000067951552607195656910000006693194055658498237_)",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    cx: 2124.14,
    cy: 1816.45,
    r: 206.03
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066516171594668242570000003973778964606666650_",
    gradientUnits: "userSpaceOnUse",
    x1: 1678.4609,
    y1: 2359.0688,
    x2: 1321.5391,
    y2: 2153
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3A84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4304,
    style: {
      stopColor: "#383785"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4D3088"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000066516171594668242570000003973778964606666650_)",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    cx: 1500,
    cy: 2256.03,
    r: 206.03
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000039838556492267440360000003340473588415667598_",
    cx: 844.8276,
    cy: 1788.8621,
    r: 265.1635,
    gradientTransform: "matrix(-0.866 -0.5 4.5 -7.7942 -6473.4097 16154.0762)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C2D88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3334,
    style: {
      stopColor: "#9A2E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5712,
    style: {
      stopColor: "#942E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7793,
    style: {
      stopColor: "#882E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9693,
    style: {
      stopColor: "#772F88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#742F88"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000039838556492267440360000003340473588415667598_)",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    cx: 862.07,
    cy: 1816.45,
    r: 206.03
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000177464699601679690220000002156897524636173952_",
    cx: 862.069,
    cy: 1166.3793,
    r: 228.5731,
    fx: 1090.6277,
    fy: 1163.8171,
    gradientTransform: "matrix(-0.6549 0.7558 6.046 5.2388 -5625.3789 -5595.6016)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0377,
    style: {
      stopColor: "#9C2D88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4603,
    style: {
      stopColor: "#9B2E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6125,
    style: {
      stopColor: "#962E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    style: {
      stopColor: "#8D2F88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8087,
    style: {
      stopColor: "#803088"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8838,
    style: {
      stopColor: "#6F3087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9491,
    style: {
      stopColor: "#5A3187"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#433186"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000177464699601679690220000002156897524636173952_)",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    cx: 862.07,
    cy: 1166.38,
    r: 206.03
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108989042072260148650000001034153739136691901_",
    gradientUnits: "userSpaceOnUse",
    x1: 1181.8966,
    y1: 1331.0344,
    x2: 1393.9656,
    y2: 1331.0344
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C2D88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046,
    style: {
      stopColor: "#972E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2101,
    style: {
      stopColor: "#882F88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    style: {
      stopColor: "#7D2F88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6231,
    style: {
      stopColor: "#773088"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#753088"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000108989042072260148650000001034153739136691901_)",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    cx: 1287.93,
    cy: 1331.03,
    r: 106.03
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013912467853246265390000012019043381832273847_",
    gradientUnits: "userSpaceOnUse",
    x1: 1494.363,
    y1: 1278.0261,
    x2: 1678.0508,
    y2: 1171.9739
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F3087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3806,
    style: {
      stopColor: "#4C3187"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7121,
    style: {
      stopColor: "#413586"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9975,
    style: {
      stopColor: "#2E3985"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#283985"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000013912467853246265390000012019043381832273847_)",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    cx: 1586.21,
    cy: 1225,
    r: 106.03
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061451093185087740820000007837038720520963466_",
    gradientUnits: "userSpaceOnUse",
    x1: 1172.9878,
    y1: 1549.2292,
    x2: 1322.9432,
    y2: 1699.1846
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#992E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1649,
    style: {
      stopColor: "#8E2E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4301,
    style: {
      stopColor: "#802F88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    style: {
      stopColor: "#772F88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9975,
    style: {
      stopColor: "#743088"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000061451093185087740820000007837038720520963466_)",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    cx: 1247.97,
    cy: 1624.21,
    r: 106.03
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178186577760377381190000001001132393573312899_",
    gradientUnits: "userSpaceOnUse",
    x1: 1399.069,
    y1: 1748.6089,
    x2: 1471.6206,
    y2: 1947.9427
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0187,
    style: {
      stopColor: "#9C2D88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6548,
    style: {
      stopColor: "#673688"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9975,
    style: {
      stopColor: "#4A3888"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000178186577760377381190000001001132393573312899_)",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    cx: 1435.34,
    cy: 1848.28,
    r: 106.03
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106858479002681233710000008900490974277943465_",
    gradientUnits: "userSpaceOnUse",
    x1: 1720.2251,
    y1: 1509.9226,
    x2: 1903.9128,
    y2: 1403.8705
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#453389"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5061,
    style: {
      stopColor: "#433488"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8197,
    style: {
      stopColor: "#3A3787"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9975,
    style: {
      stopColor: "#2E3985"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000106858479002681233710000008900490974277943465_)",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    cx: 1812.07,
    cy: 1456.9,
    r: 106.03
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029047398757750433780000002099065198886906814_",
    gradientUnits: "userSpaceOnUse",
    x1: 1828.4482,
    y1: 1764.7241,
    x2: 1616.3793,
    y2: 1764.7241
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3A84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#503088"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000029047398757750433780000002099065198886906814_)",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    cx: 1722.41,
    cy: 1764.72,
    r: 106.03
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    className: "st26"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st27",
    cx: 316.93,
    cy: 20.62,
    rx: 205.17,
    ry: 148.28
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st28",
    cx: 996.55,
    cy: 20.62,
    rx: 291.38,
    ry: 136.21
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st29",
    cx: 1979.52,
    cy: 23.21,
    rx: 291.38,
    ry: 136.21
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTextLogo);
export default __webpack_public_path__ + "static/media/no-text-logo.ed7163fa132387b479dd8282dae06312.svg";
export { ForwardRef as ReactComponent };